const StatisticalArticle = () =>
  import('@/views/main/promotion/statisticalArticle/StatisticalArticle.vue')
export default {
  path: '/main/promotion/statisticalArticle',
  name: 'StatisticalArticle',
  component: StatisticalArticle,
  children: []
}
